import { Provider } from 'mobx-react';
import React from 'react';
import { ReactAI } from 'react-appinsights';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';

import * as serviceWorker from './serviceWorker';
import { stores } from './stores';

import { createBrowserHistory } from 'history';
import { runWithAdal } from 'react-adal';

import App from './components/App';

import 'ant-design-pro/dist/ant-design-pro.css';
import 'antd/dist/antd.css';

const GlobalStyle = createGlobalStyle`
    html {
        overflow-y: overlay;
    }
    html, body {
        width: 100% !important;
        min-height: 100vh;
    }

    #root {
        height: 100%;
    }
`;

const history = createBrowserHistory();
const instrumentationKey = '00000000-0000-0000-0000-0000000000000';
    //process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY || '00000000-0000-0000-0000-0000000000000';

/*ReactAI.initialize({
    instrumentationKey,
    history,
    enableCorsCorrelation: true,
    isStorageUseDisabled: true
});*/

// tells react-adal to not login the user upon landing on the homepage
const DO_NOT_LOGIN = true;

// runWithAdal(
//     stores.authStore.authContext,
    // () => {
        ReactDOM.render(
            <>
                <GlobalStyle />
                <Provider {...stores}>
                    <Router history={history}>
                        <App />
                    </Router>
                </Provider>
            </>,
            document.getElementById('root') as HTMLElement
        );
    // }
//     ,
//     DO_NOT_LOGIN
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
